import { Link } from 'react-router-dom';

const cities = [
  { name: 'Ratingen', active: true },
  { name: 'Düsseldorf', active: false },
  { name: 'Mettmann', active: false },
  { name: 'Erkrath', active: false },
  { name: 'Hilden', active: false },
  { name: 'Langenfeld', active: false },
  { name: 'Velbert', active: false },
  { name: 'Heiligenhaus', active: false },
  { name: 'Wülfrath', active: false },
  { name: 'Neuss', active: false },
  { name: 'Krefeld', active: false },
];

export default function LocationSection() {
  return (
    <section className="py-12 sm:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-[#0D2B4E]/5 rounded-full px-4 sm:px-5 py-2 mb-4 sm:mb-5">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-map-pin-line text-[#0D2B4E] text-base sm:text-lg" />
            </div>
            <span className="text-xs sm:text-sm font-semibold text-[#0D2B4E] tracking-wide">
              Unser Einzugsgebiet
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Ratingen &amp; Umgebung
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Wir realisieren Bau- und Sanierungsprojekte in{' '}
            <strong>Ratingen</strong> und der gesamten Region NRW – mit lokaler Expertise und
            kurzen Anfahrtszeiten.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center max-w-6xl mx-auto">
          {/* Map */}
          <div className="order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden border-4 border-[#0D2B4E]/10">
              <div className="aspect-[4/3] w-full">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d40486.89!2d6.8499!3d51.2966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b8c9c0c0c0c0c0%3A0x0!2sRatingen!5e0!3m2!1sde!2sde!4v1234567890"
                  width="100%"
                  height="100%"
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="IGM Facility Service Einzugsgebiet Ratingen"
                  className="w-full h-full"
                />
              </div>
              <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm rounded-lg px-4 py-2">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-[#0D2B4E] rounded-full animate-pulse" />
                  <span className="text-sm font-bold text-gray-900">Ratingen 40878</span>
                </div>
              </div>
            </div>
          </div>

          {/* Cities */}
          <div className="order-1 lg:order-2">
            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border border-gray-200">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-[#0D2B4E] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-2-line text-2xl text-white" />
                </div>
                <div>
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900">Wir sind für Sie da</h3>
                  <p className="text-sm text-gray-600">In diesen Städten im Einsatz</p>
                </div>
              </div>

              <div className="flex flex-wrap gap-2 sm:gap-3 mb-6">
                {cities.map((city) => (
                  <div
                    key={city.name}
                    className={`px-4 py-2 rounded-lg font-semibold text-sm transition-all cursor-default ${
                      city.active
                        ? 'bg-[#0D2B4E] text-white'
                        : 'bg-white text-gray-700 border border-gray-300 hover:border-[#0D2B4E] hover:text-[#0D2B4E]'
                    }`}
                  >
                    {city.active && <i className="ri-home-heart-fill mr-1" />}
                    {city.name}
                  </div>
                ))}
              </div>

              <div className="space-y-3 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#0D2B4E]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-[#0D2B4E] text-sm" />
                  </div>
                  <p className="text-sm text-gray-700">
                    <strong>Schnelle Anfahrt:</strong> Innerhalb von 30 Minuten bei Ihnen vor Ort
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#0D2B4E]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-[#0D2B4E] text-sm" />
                  </div>
                  <p className="text-sm text-gray-700">
                    <strong>Lokale Expertise:</strong> Wir kennen die Region und ihre Anforderungen
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#0D2B4E]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-[#0D2B4E] text-sm" />
                  </div>
                  <p className="text-sm text-gray-700">
                    <strong>Flexible Einsatzzeiten:</strong> 24/7 Notdienst für Schlüsseldienst
                    verfügbar
                  </p>
                </div>
              </div>

              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center gap-2 bg-[#0D2B4E] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#0a2240] transition-colors w-full cursor-pointer whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-lg" />
                </div>
                <span>Jetzt anfragen</span>
              </Link>
            </div>
          </div>
        </div>

        <div className="text-center mt-10 sm:mt-12">
          <p className="text-gray-500 text-sm">
            Ihre Stadt ist nicht dabei?{' '}
            <Link to="/kontakt" className="text-[#0D2B4E] font-semibold hover:underline cursor-pointer">
              Kontaktieren Sie uns
            </Link>{' '}
            – wir prüfen gerne, ob wir auch in Ihrer Region tätig werden können.
          </p>
        </div>
      </div>
    </section>
  );
}
